import { create } from 'zustand'

interface HeaderState {
  title: string
  // Live second line under the compact title, e.g. "3 of 10 left".
  subtitle: string
  scrolled: boolean
  // Content has scrolled under the app header (scrollTop > 0): frost it.
  raised: boolean
  setTitle: (title: string) => void
  setSubtitle: (subtitle: string) => void
  setScrolled: (scrolled: boolean) => void
  setRaised: (raised: boolean) => void
}

export const useHeaderStore = create<HeaderState>((set) => ({
  title: '',
  subtitle: '',
  scrolled: false,
  raised: false,
  setTitle: (title) => set({ title }),
  setSubtitle: (subtitle) => set({ subtitle }),
  setScrolled: (scrolled) => set({ scrolled }),
  setRaised: (raised) => set({ raised }),
}))
